export const USD_CURRENCY = 'USD';

export const SALARY_PERIODS = [
  { value: 'hourly', label: 'Hourly' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' }
];

export const OFFER_SALARY_PERIODS = [
  ...SALARY_PERIODS,
  { value: 'one_time', label: 'One time' }
];

export const salaryPeriodLabel = (period) => (
  SALARY_PERIODS.find((item) => item.value === period)?.label ||
  OFFER_SALARY_PERIODS.find((item) => item.value === period)?.label ||
  null
);

export const formatCompensationRange = (salary, emptyLabel = null) => {
  const toAmount = (value) => {
    if (value === null || value === undefined || value === '') return null;
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
  };
  const min = toAmount(salary?.min);
  const max = toAmount(salary?.max);
  if (min === null && max === null) return emptyLabel;

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: USD_CURRENCY,
    maximumFractionDigits: 0
  });
  const amount = min !== null && max !== null
    ? `${formatter.format(min)} - ${formatter.format(max)}`
    : formatter.format(min ?? max);
  const period = salaryPeriodLabel(salary?.period);
  return period ? `${amount} / ${period.toLowerCase()}` : `${amount} / period not set`;
};
